export enum MFADeviceTypeEnum {
    Unknown = 0,
    SMS = 1,
    Email = 2,
}
